import get from 'lodash/get'

/**
 * Return true if the version is less than the versionToMigrate else false
 *
 * @param {integer} versionToMigrate
 */
export default function (config, migrateVersion) {
  const configVersion = get(config, '_version', -1)
  return configVersion < migrateVersion
}
